import { render, staticRenderFns } from "./ProductCategoryListPopupIframe.vue?vue&type=template&id=37a4c8f2&"
import script from "./ProductCategoryListPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryListPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports